import { Pipe, PipeTransform } from '@angular/core';
import { SLEntityType } from './entity';

@Pipe({ name: 'slentitytype' })
export class SLEntityTypePipe implements PipeTransform {
 
  transform(value: SLEntityType, ...args: any[]) {
    if (value === 'COMPANY') {
      return 'Société';
    }
    else if(value === 'PERSON') {
      return 'Personne';
    }
    else {
      return value;
    }
  }
}
